module.exports = __webpack_public_path__ + "2974544031b39e6781831e315fff921b.png";